export default __webpack_public_path__ + "media/images/icons/arrow-white-next-4a0650b4a6ad57e3b39ec79b92d1da7d.png";